export const fixed2Position = (input: number | string) => `0${input}`.slice(-2);

export const convertHDP = (hdp?: string, isDisplayPlus?: boolean) => {
  if (!hdp) return "";
  const isMinus = hdp.includes("-");
  const isZero = Number(hdp) === 0;

  const [first, second] = hdp?.replace("-", "")?.split("/") ?? [];
  if (second) {
    return (
      (!isMinus && isDisplayPlus && !isZero ? "+" : "") +
      Number(
        (((Number(first) + Number(second)) / 2) * (isMinus ? -1 : 1)).toFixed(
          2,
        ),
      )
    );
  }

  return (
    (!isMinus && isDisplayPlus && !isZero ? "+" : "") +
    Number(Number(hdp).toFixed(2))
  );
};

export const dashHDP = (hdp?: string | number) => {
  if (hdp == null) return "";
  return `${hdp}`.replace("/", "-");
};

export const cleanCornerId = (cornerId: string | number) => {
  return `${cornerId}`.replace(/0000000\d$/g, "");
};

export const flipObject = (data: Record<string, string>) =>
  Object.fromEntries(Object.entries(data)?.map(([key, value]) => [value, key]));
